import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {SendTextDialogController} from '../SendTextDialog.controller';

@observer
export class SendTextDialogToolbar extends TechseeBaseComponent<{ctrl: SendTextDialogController}> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;
        return (
            <div className='sub-modal-footer'>
                {!ctrl.text && ctrl.showNotification && (
                    <span className='text-danger'>{ctrl.translate('SEND_TEXT.VIEW.TYPE_MESSAGE')}</span>
                )}
                {!ctrl.isReadonly && (
                    <button
                        className='btn btn-primary'
                        type='button'
                        disabled={ctrl.isEndMeeting}
                        onClick={ctrl.handleOk}>
                        {ctrl.translate('SEND_TEXT.VIEW.OK')}
                    </button>
                )}
                <button className='btn btn-warning' type='button' onClick={ctrl.close}>
                    {ctrl.translate('SEND_TEXT.VIEW.CANCEL')}
                </button>
            </div>
        );
    }
}
